import { render, staticRenderFns } from "./JobTimeBanner.vue?vue&type=template&id=0488100c&scoped=true&"
import script from "./JobTimeBanner.vue?vue&type=script&lang=js&"
export * from "./JobTimeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488100c",
  null
  
)

export default component.exports